export const BILLING_INTERSTITIAL = 'BILLING_INTERSTITIAL';
export const INTERNET_INTERSTITIAL = 'INTERNET_INTERSTITIAL';
export const MOVING_INTERSTITIAL = 'MOVING_INTERSTITIAL';
export const LOADING_WITH_TEXT = 'LOADING_WITH_TEXT';
export const OUTAGE_INTERSTITIAL = 'OUTAGE_INTERSTITIAL';
export const TV_INTERSTITIAL = 'TV_INTERSTITIAL';
export const SCHEDULE_CALL = 'SCHEDULE_CALL';
export const SELECT_INTENT = 'SELECT_INTENT';
export const CALL_CONFIRMED = 'CALL_CONFIRMED';
export const CALL_CANCELLED = 'CALL_CANCELLED';
export const CONFIRM_CANCELLED = 'CONFIRM_CANCELLED';
export const ERROR = 'ERROR';
export const UNAVAILABLE = 'UNAVAILABLE';
